export default "__VITE_ASSET__oUaH5mSj__";